import ndarray from 'ndarray';
import ops from 'ndarray-ops';
import { Tensor } from 'onnxruntime-web';

function preprocess(ctx) {
    const imageData = ctx.getImageData(
        0,
        0,
        ctx.canvas.width,
        ctx.canvas.height,
    );
    const { data } = imageData;
    const width = 256;
    const height = 256;

    // data processing
    const dataTensor = ndarray(new Float32Array(data), [width, height, 4]);
    const dataProcessedTensor = ndarray(new Float32Array(width * height * 3), [
        1,
        3,
        width,
        height,
    ]);

    ops.assign(
        dataProcessedTensor.pick(0, 0, null, null),
        dataTensor.pick(null, null, 0),
    );
    ops.assign(
        dataProcessedTensor.pick(0, 1, null, null),
        dataTensor.pick(null, null, 1),
    );
    ops.assign(
        dataProcessedTensor.pick(0, 2, null, null),
        dataTensor.pick(null, null, 2),
    );

    const tensor = new Tensor('float32', new Float32Array(width * height * 3), [
        1,
        3,
        width,
        height,
    ]);
    tensor.data.set(dataProcessedTensor.data);
    return tensor;
}

export default preprocess;
